import React from 'react';
import profile from "../images/profile.png";


function Home () {

  return (
    <div className="container">
      <div className="row">
        <div className="col name-div">
          <h3 className="name">Rex Osariemen</h3>
          <h5>Software Engineer</h5>
        </div>
        <div className="col home-image">
          <img id="home-image" src={profile} alt="Rex Osariemen" width="200" height=""/>
        </div>
      </div>
      <hr />
      <div className="skills">
        <div className="skill-section">
          <h4>Languages:</h4>
          <p>Javascript (ES6+), Python3</p>
        </div>
        <div className="skill-section">
          <h4>Front End:</h4>
          <p>React, Redux, D3.js, Webpack, SASS/SCSS, Bootstrap</p>
        </div>
        <div className="skill-section">
          <h4>Back End:</h4>
          <p>Node.js, Express, SQL, NoSQL</p>
        </div>
        <div className="skill-section">
          <h4>Others:</h4>
          <p>Docker, Kubernetes, AWS, GraphGL, TravisCI</p>
        </div>
      </div>
    </div>
  )
}

export default Home;